$(document).ready(function () {

    cafm.web.load();

    if (cafm.loadBegin && cafm.loadBegin.length) {

        $.each(cafm.loadBegin, function (i, loadItem) {

            loadItem();
        });
    }

    // store the timezone offset for quick access later (but it could change!)
    cafm.res.timezoneOffset = new Date().getTimezoneOffset();
    
    // init security if it is not setup/error/page not found page
    if (!cafm.url.isSetup() && !cafm.url.isError() && !cafm.url.isPageNotFound()) {

        cafm.auth.init();
    }

    if (cafm.loadEnd && cafm.loadEnd.length) {

        $.each(cafm.loadEnd, function (i, loadItem) {

            loadItem();
        });
    }
})